export function canShowPublicBookListCart(bookList) {
  return bookList?.isPublic === true
    && !!bookList?.allowPublicCart
    && !(Number(bookList?.discountPercentage) > 0)
    && (bookList.bookListItems?.length || 0) > 0;
}
